<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">本地安全码</span>
      </div>
      <div class="right">
        <Button style="margin-right: 5px" @click="excelModalShow">导入</Button>
        <Poptip title="导出" placement="left" trigger="hover">
          <Button style="margin: 0 5px 1px 0">导出</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportExcel(0)">导出当前页</Button>
            <Button type="success" @click="exportExcel(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button type="primary" @click="addModal">新增安全码</Button>
      </div>
    </div>
    <div style="margin:20px 0">
      <span class="subtitle" style="margin-right: 10px">所在仓库:</span>
      <Select v-model="page.storage" style="width: 120px; margin-right: 15px">
        <Option value="全部">全部</Option>
        <Option
          v-for="(item, index) in storage"
          :key="index"
          :value="item.storage"
        >{{ item.storage }}</Option>
      </Select>
      <span class="subtitle" style="margin-right: 10px">当前状态:</span>
      <Select v-model="page.status" style="width: 100px; margin-right: 15px">
        <Option :value="-1">全部</Option>
        <Option :value="0">未激活</Option>
        <Option :value="1">已激活</Option>
      </Select>
      <span class="subtitle" style="margin-right: 10px">所属类型:</span>
      <Select v-model="page.type" style="width: 100px; margin-right: 15px">
        <Option :value="-1">全部</Option>
        <Option :value="0">设备激活</Option>
        <Option :value="1">负载均衡</Option>
        <Option :value="2">文件留底</Option>
      </Select>
      <span class="subtitle">入库时间:</span>
      <DatePicker
        type="daterange"
        v-model="date"
        placeholder="选择时间"
        style="width: 200px; margin-left: 10px"
      ></DatePicker>
      <Button style="margin-left: 13px" type="primary" @click="getData">查询</Button>
      <Button style="margin-left: 13px" @click="reset">清空</Button>
    </div>
    <div>
      <Table :columns="columns" :data="data" :loading="loading" @on-sort-change="tableSort"></Table>
      <div class="t-right" style="margin-top:10px;">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :page-size-opts="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
          :total="total"
          :current="page.p + 1"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>

    <Modal :width="500" title="新增安全码" v-model="visible">
      <Form ref="formInline" :model="current" :rules="rule" :label-width="70">
        <FormItem prop="storage" label="仓库:">
          <Input v-model="current.storage" placeholder="手动输入" style="width:250px;">
            <Select v-model="current.storage" slot="append" style="width: 93px" placeholder="手动选择">
              <Option
                v-for="(item, index) in storage"
                :key="index"
                :value="item.storage"
              >{{ item.storage }}</Option>
            </Select>
          </Input>
          <div class="describe">请选择安全码入库仓库，新仓库请直接输入名称</div>
        </FormItem>

        <FormItem prop="num" label="数量:">
          <InputNumber :min="1" v-model="current.num" :precision="0" style="width:150px;"></InputNumber>
        </FormItem>
        <FormItem prop="num" label="类型:">
          <RadioGroup v-model="current.type">
            <Radio label="0">设备激活</Radio>
            <Radio label="1">负载均衡</Radio>
            <Radio label="2">文件留底</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="visible = false">取消</Button>
        <Button @click="modalClick" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
export default {
  data () {
    this.statusObj = {
      0: { name: '未激活', color: '#19be6b' },
      1: { name: '已激活', color: '#ed4014' }
    }
    return {

      storage: [],
      columns: [
        { key: 'id', title: '编号' },
        { key: 'code', title: '安全码' },
        {
          key: 'status',
          title: '状态',
          render: (h, data) => {
            return h(
              'span',
              { style: { color: this.statusObj[data.row.status].color } },
              this.statusObj[data.row.status].name
            )
          }
        },
        {
          key: 'type',
          title: '类型',
          render: (h, data) => {
            let type = {
              0: '设备激活',
              1: '负载均衡',
              2: '文件留底'
            }
            return h('span', {}, type[data.row.type])
          }
        },
        { key: 'storage', width: 120, title: '仓库' },
        {
          key: 'create_time',
          title: '入库时间',
          width: 170,
          sortable: 'custom',
          show: true,
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          }
        },
        {
          key: 'use_time',
          width: 170,
          title: '激活时间',
          sortable: 'custom',
          show: true,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.use_time ? this.$moment(data.row.use_time) : ''
            )
          }
        }
      ],
      data: [],
      loading: false,
      page: {
        l: 10,
        p: 0,
        storage: '全部',
        status: -1,
        type: -1
      },
      total: 0,
      date: [],
      excelCode: {
        status: false,
        file: {}
      },
      visible: false,
      current: {
        storage: '',
        num: 10,
        type: '0'
      },
      rule: {
        storage: [
          {
            required: true,
            type: 'string',
            trigger: 'blur',
            message: '仓库未选'
          }
        ],

        num: [
          {
            required: true,
            type: 'number',
            trigger: 'blur',
            message: '数量必填'
          }
        ]
      }
    }
  },
  mounted () {
    this.GetSafetyStorage().then((res) => {
      this.storage = res.data
      this.getData()
    })
  },
  methods: {
    // 表格排序
    tableSort (col) {
      this.page.key = col.key
      this.page.order = col.order
      this.getData()
    },
    getData () {
      const params = { ...this.page }
      console.log('this.date', this.date)
      if (this.date.length === 2 && this.date[0] && this.date[1]) {
        params.start = this.$moment(this.date[0], 'YYYY-MM-DD')
        params.end = this.$moment(this.date[1], 'YYYY-MM-DD')
      }
      if (params.storage === '全部') params.storage = ''
      this.GetSafetyCode(params).then(res => {
        this.data = res.data
        this.total = res.total
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    reset () {
      this.page = {
        l: 10,
        p: 0,
        storage: '',
        status: -1,
        type: -1
      }
      this.date = []
      this.getData()
    },
    exportExcel (type) {
      if (type) {
        // 所有
        const params = { ...this.page }
        params.p = 0
        params.l = this.total
        console.log('this.date', this.date)
        if (this.date.length === 2 && this.date[0] && this.date[1]) {
          params.start = this.$moment(this.date[0], 'YYYY-MM-DD')
          params.end = this.$moment(this.date[1], 'YYYY-MM-DD')
        }
        if (params.storage === '全部') params.storage = ''
        this.loading = true
        this.GetSafetyCode(params).then((res) => {
          this.loading = false
          this.doExport(res.data)
        })
      } else {
        // 当前页
        let data = JSON.parse(JSON.stringify(this.data))
        this.doExport(data)
      }
    },
    doExport (data) {
      const statusArr = {
          0: '未使用',
          1: '已使用'
        }, typeArr = {
          0: '设备激活',
          1: '负载均衡',
          2: '文件留底'
        }
      data.map((item) => {
        item.status = statusArr[item.status]
        item.type = typeArr[item.type]
        item.create_time = this.$moment(item.create_time)
        item.datetime = item.bind_time ? this.$moment(item.bind_time) : ''
      })
      try {
        let params = {
          title: [],
          key: [],
          autoWidth: true,
          filename: '安全码',
          data: data
        }
        this.columns.map((item) => {
          params.title.push(item.title)
          params.key.push(item.key)
        })
        console.log(132, params)
        excel.export_array_to_excel(params)
      } catch (error) {
        console.log(error)
      }
    },
    excelModalShow () {
      this.excelCode.file = {}
      this.excelCode.status = true
    },
    addModal () {
      this.visible = true
      this.$refs.formInline.resetFields()
    },
    modalClick () {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          const params = { ...this.current }
          params.type = parseInt(params.type)
          this.loading = true
          this.AddSafety(params).then((res) => {
            this.loading = false
            if (res) {
              this.reset()
              this.visible = false
              this.current = {
                storage: '',
                num: 10,
                type: '0'
              }
            }
          })
        }
      })
    },
    ...mapActions([
      'GetSafetyStorage',
      'GetSafetyCode',
      'AddSafety'
    ])
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
